module.exports = __webpack_public_path__ + "images/stickers/clock.5bd7338f370c3fd7238d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/clock.png
// module id = ybYo
// module chunks = 12